module.exports = __webpack_public_path__ + "static/media/people.33c40c41.png";